import React, { useEffect, useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { clearChangeTripReasonTypes, getChangeTripReasonTypes, getChangeTripReasonTypesByCategory } from '../../../../actions';
import { DEFAULT_SELECT_PLACEHOLDER } from '../../../../config/constants';
import Select from './Select';
import { optionsPropTypes } from './SelectPropTypes';

const ChangeTripReasonTypeSelect = ({
  dispatchClearChangeTripReasonTypes,
  dispatchGetChangeTripReasonTypes,
  loading,
  options,
  categoryId,
  dispatchGetChangeTripReasonTypesByCategory,
  ...rest
}) => {
  useLayoutEffect(() => {
    if (!categoryId) {
      dispatchGetChangeTripReasonTypes();
    } 
    return () => {
      dispatchClearChangeTripReasonTypes();
    };
  }, [dispatchGetChangeTripReasonTypes, dispatchClearChangeTripReasonTypes]);

  useEffect(() => {
    if (categoryId) {
      dispatchClearChangeTripReasonTypes();
      dispatchGetChangeTripReasonTypesByCategory(categoryId);
    }
  }, [categoryId, dispatchGetChangeTripReasonTypesByCategory]);

  return (
    <Select
      options={options}
      placeholder={DEFAULT_SELECT_PLACEHOLDER}
      isLoading={loading}
      {...rest}
    />
  );
};

ChangeTripReasonTypeSelect.propTypes = {
  dispatchClearChangeTripReasonTypes: PropTypes.func.isRequired,
  dispatchGetChangeTripReasonTypes: PropTypes.func.isRequired,
  options: optionsPropTypes.isRequired,
  loading: PropTypes.bool,
  categoryId: PropTypes.number,
  dispatchGetChangeTripReasonTypesByCategory: PropTypes.func.isRequired,
};

ChangeTripReasonTypeSelect.defaultProps = {
  loading: false,
  categoryId: null,
}

const mapDispatchToProps = {
  dispatchClearChangeTripReasonTypes: clearChangeTripReasonTypes,
  dispatchGetChangeTripReasonTypes: getChangeTripReasonTypes,
  dispatchGetChangeTripReasonTypesByCategory: getChangeTripReasonTypesByCategory
};

const mapStateToProps = ({ ItineraryUnit }) => ({
  loading: ItineraryUnit.Itinerary.getIn(['current', 'changeTripReasonTypesLoading']),
  options: ItineraryUnit.Itinerary.getIn(['current', 'changeTripReasonTypes']).map(type => ({
    value: type.id,
    label: type.description
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(ChangeTripReasonTypeSelect);
